import { type VoidFunctionComponent } from 'react';

import { Action } from '../../../../../../../../../typings/permissions';
import { userHasPermissionForTeamReleaseGroups } from '../../../../../../../../helpers/permissions';
import FilterCardMultiSelect from '../../../../../../../generic/Filter/FilterCardMultiSelect';
import type { UseTeamsSelectOptionsReturn } from '../../../../../../../shared/teams/hooks/useTeamsSelectOptions';

import styles from '../../../ReleaseGroupsRevamp.module.less';

const userCanAddReleaseGroupToTeam = (teamId: number): boolean =>
  userHasPermissionForTeamReleaseGroups(Action.Add, teamId);

export type TeamSelectorProps = Pick<UseTeamsSelectOptionsReturn, 'teamOptions' | 'selectedTeamOptions' | 'onTeamsSelected'>;

/**
 * TeamSelector is used on the Policies page to allow the
 * user to assign a release group to one or more teams.
 */
const TeamSelector: VoidFunctionComponent<TeamSelectorProps> = ({
  teamOptions,
  selectedTeamOptions,
  onTeamsSelected,
}) => (
  <div className={`${styles.detailsInputs} ${styles.detailsInputsSolo}`}>
    <FilterCardMultiSelect
      label="Teams"
      requiredText="(optional)"
      placeholder="Select one or more teams to assign this release group to"
      options={teamOptions.filter(team => userCanAddReleaseGroupToTeam(team.value))}
      values={selectedTeamOptions}
      onChange={onTeamsSelected}
      isSearchable
    />
  </div>
);

export default TeamSelector;
